import React, { Fragment } from 'react';

import transparentize from 'polished/lib/color/transparentize';
import { colors } from '../../../utils/utils';
import { phraseTypes } from '../../../utils/words';
import { Label, Wrapper, WordsCount, BonusCount, BonusLabelWrapper } from './styled/CallResultPopupCallInfoStyled';

const renderStatistic = (isBonus: boolean, bonusCount: number, spottedPhrasesScore: number, totalPhrasesScore: number) => {
    const spottedBlock = <WordsCount $type={phraseTypes.SPOTTED_PHRASES}>{spottedPhrasesScore}</WordsCount>;

    if (isBonus) {
        return (
            <Fragment>
                {spottedBlock}
                <BonusCount>+{bonusCount}</BonusCount>
            </Fragment>
        );
    }
    return (
        <Fragment>
            {spottedBlock}
            <Label $fontSize="24px" $color={transparentize(0.8, colors.gray.dark)}>
                /
            </Label>
            <WordsCount $type={phraseTypes.TOTAL_PHRASES}>{totalPhrasesScore}</WordsCount>
        </Fragment>
    );
};

const renderDescription = (isBonus: boolean, isLastCallResult: boolean, localization: { getText: (key: string) => string }) => {
    const type = isLastCallResult ? 'last' : 'current';

    if (!isBonus) {
        return <Label>{localization.getText(`trainer.call_popup.${type}_call_score`)}</Label>;
    }
    return (
        <BonusLabelWrapper>
            <Label $fontSize="14px" $fontWeight="normal">
                {localization.getText(`trainer.call_popup.${type}_call`)}
            </Label>
            <Label>{localization.getText('trainer.call_popup.bonus_score')}</Label>
        </BonusLabelWrapper>
    );
};

interface LocalizationLike {
    getText: (key: string) => string;
}
interface CallInfoProps {
    spottedPhrasesScore?: number;
    totalPhrasesScore?: number;
    localization: LocalizationLike;
    isLastCallResult: boolean;
    bonusScore?: number;
}

function CallInfo(props: CallInfoProps) {
    const { spottedPhrasesScore, totalPhrasesScore, isLastCallResult, localization, bonusScore } = props;
    const safeSpottedPhrasesScore = spottedPhrasesScore ?? 0;
    const safeTotalPhrasesScore = totalPhrasesScore ?? 0;
    const safeBonusScore = bonusScore ?? 0;
    const isBonus = safeBonusScore > 0;

    return (
        <Wrapper>
            {renderDescription(isBonus, isLastCallResult, localization)}
            {renderStatistic(isBonus, safeBonusScore, safeSpottedPhrasesScore, safeTotalPhrasesScore)}
        </Wrapper>
    );
}

CallInfo.defaultProps = {
    spottedPhrasesScore: 0,
    totalPhrasesScore: 0,
    bonusScore: 0
};

export default CallInfo;
